import { axios } from "~/plugins/request"

export const state = () => {
  return {}
}
export const mutations = {}
export const actions = {
  addCode({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`redeem/insertRedeem`, params)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  findList({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`redeem/selectHeadList`, params)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  addHeaderCode({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`redeem/insertHeadRedeem`, params)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  findCodeList({commit}, params) {
    return new Promise((resolve, reject) => {
      axios.post(`redeem/selectHeadNumberList`, params)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  exportData({commit}, params) {
    return new Promise((resolve, reject) => {
      axios.post(`redeem/exportHeadRedeemNumData`, params)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  findById({commit}, params) {
    return new Promise((resolve, reject) => {
      axios.get(`redeem/findHeadRedeemNumById`, {params})
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  updateHeaderCode({commit}, params) {
    return new Promise((resolve, reject) => {
      axios.post(`redeem/updateHeaderCode`, params)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

}
